<template>
	<div v-if="current_stat">
		<h4>Здорово!</h4>
		<p>Поздравляем с прохождением.</p>
		<p><strong>Ты справился за:</strong> {{ current_stat.time.minutes }} минут, {{ current_stat.time.seconds }} секунд </p>
		<p><strong>Совершил ошибок:</strong> {{ current_stat.errors }}</p>
	</div>
</template>

<script>
  import { mapState } from 'vuex';
  export default {
    name: "finish",
    props: {
      items: ''
    },
    computed: {
      ...mapState({
        current_stat: state => state.current_stat
      })
    },
    beforeDestroy() {
      this.$parent.commitVal(false, 'finish')
    }
  }
</script>